export default __webpack_public_path__ + "static/media/about1.020c1721.jpg";